"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var EventBufferConfiguration_1 = require("../eventbufferconfiguration/EventBufferConfiguration");
/**
 * [[EventIngestionConfiguration]] contains necessary information to
 * report events to the ingestion service.
 */


var EventIngestionConfiguration = function EventIngestionConfiguration(eventsClientConfiguration, ingestionURL) {
  var eventBufferConfiguration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new EventBufferConfiguration_1.default();

  _classCallCheck(this, EventIngestionConfiguration);

  this.eventsClientConfiguration = eventsClientConfiguration;
  this.ingestionURL = ingestionURL;
  this.eventBufferConfiguration = eventBufferConfiguration;
};

exports.default = EventIngestionConfiguration;